import { render, staticRenderFns } from "./TopicBox.vue?vue&type=template&id=257edfd6&scoped=true&"
import script from "./TopicBox.vue?vue&type=script&lang=js&"
export * from "./TopicBox.vue?vue&type=script&lang=js&"
import style0 from "./TopicBox.vue?vue&type=style&index=0&id=257edfd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257edfd6",
  null
  
)

export default component.exports